// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"51":"faf458ab","239":"34a7c2df","977":"1be85e5f"}[chunkId] + ".chunk.js";
};